import React from "react";
import { InfoLabel } from "./components/InfoLabel";
import { GroupedFolder } from "./types";
import { Link } from "react-router-dom";
import { project } from "~/routes";
import styled from "@emotion/styled";
import { Body1 } from "@material/react-typography";

const ProjectNumbersContainter = styled("div")`
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ProjectsLabel = styled(Body1)`
  &.mdc-typography--body1 {
    padding: 0 0.5rem;
    margin-bottom: 0;
  }

  font-weight: bold;
`;

const ProjectLink = styled(Body1)`
  &.mdc-typography--body1 {
    padding: 0;
    margin: 0;
  }

  a {
    border-bottom: 1px solid var(--mdc-theme-primary);
  }
`;

type GroupedFolderInfoProps = {
  folder: GroupedFolder;
};

export const GroupedFolderInfo: React.FC<GroupedFolderInfoProps> = ({
  folder,
}) => {
  const { name, projectNumbers } = folder;
  return (
    <>
      <InfoLabel>
        <span>Grouped folder: </span>
        {name}
      </InfoLabel>
      <ProjectsLabel>
        <span>Projects:</span>
      </ProjectsLabel>
      <ProjectNumbersContainter>
        {projectNumbers?.length ? (
          projectNumbers.map((projectNumber) => (
            <ProjectLink key={projectNumber}>
              <Link to={project.toRoute(projectNumber).path}>
                {projectNumber}
              </Link>
            </ProjectLink>
          ))
        ) : (
          <InfoLabel>This folder contains no projects.</InfoLabel>
        )}
      </ProjectNumbersContainter>
    </>
  );
};
